/*global $*/
/*eslint no-undef: "error"*/
export default class Delivery {
    classItem = 'delivery--item'
    classButton = 'delivery--button'
    classButtonActive = 'delivery__button---active'
    classBlock = 'delivery--block'
    classBlockActive = 'delivery__block---active'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            let block = $(this).data(`block`)

            $(this).closest(`.${self.classItem}`).find(`.${self.classButton}`).removeClass(self.classButtonActive)
            $(this).closest(`.${self.classItem}`).find(`.${self.classButton}[data-block='${block}']`).addClass(self.classButtonActive)

            $(this).closest(`.${self.classItem}`).find(`.${self.classBlock}`).removeClass(self.classBlockActive)
            $(this).closest(`.${self.classItem}`).find(`.${self.classBlock}[data-block='${block}']`).addClass(self.classBlockActive)
        })
    }
}
